<template>
  <div>
    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
      small
    >
    <template #cell(STT)="data">
        {{ data.index + 1 }}
    </template>
    <template v-slot:cell(status)="data">
      {{data.item.status == null ? '' : findFirst(tinhtrangtaisans, data.item.status)}}
    </template>
    <template v-slot:cell(recievedDate)="data">{{formatDate(data.value)}}</template>
    <template v-slot:cell(price)="data">{{data.item.price | numeral('0,0')}}</template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ReportWorking",
  props: ["tinhtrangtaisans", "departments", "assetType"],
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: {width: "15px", textAlign : "center"},
        },
        {
          key: "assetId",
          label: "Mã TS",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "assetTypeId",
          label: "Loại TS",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "serial",
          label: "Số seri",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "price",
        //   label: "Giá",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },

        {
          key: "departmentId",
          label: "Công ty",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },

        {
          key: "recievedDate",
          label: "Ngày cấp",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "employeeId",
          label: "Người request",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "detail",
          label: "Mô tả",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "job",
        //   label: "Job",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
        // {
        //   key: "purpose",
        //   label: "Mục đích sử dụng",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
        {
          key: "status",
          label: "Tình trạng",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "notation",
        //   label: "NOTE",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: { textAlign: "center" },
        // },
      ],
      items: [],
      currentPage: null,
      totalRow: null,
      perPage: null,
      sortBy: null,
      sortDesc: null,
    };
  },
  computed: {},
  //   beforeRouteEnter(to, from, next) {

  //   },
  //   beforeRouteUpdate(to, from, next) {

  //   },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.q = "";
      // axios
      //   .get("/api/asset", { params: query })
      //   .then((response) => {
      //     this.items = response.data;
      //   })
      //   .catch((err) => {
      //   });

        axios
        .get(`/api/asset/assettype/${this.assetType.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
        });
    },
    findFirst(list, id) {
      const temp = list.find(function (el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function (el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    formatDate(value) {
      if (!value)
        return "";
      return this.$moment(value).format('DD/MM/YYYY');
    },
    paginationChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
